// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__13X6r","range":"MonthRangeSwitch_range__g52k7","disabled":"MonthRangeSwitch_disabled__10MmD"};